/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Rendering_No_EventsInputs */



/**
* | output |
* | --- |
* | "Rendering No Selected Events" |
*
* @param {Render_Audio_Rendering_No_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_rendering_no_events = /** @type {((inputs?: Render_Audio_Rendering_No_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Rendering_No_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun evenement selectionne pour le rendu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es werden keine ausgewählten Ereignisse gerendert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rendering di nessun evento selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отображение невыбранных событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se representan eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未渲染任何选定事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択されたイベントをレンダリングしません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं के बिना रेंडरिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não renderizando nenhum evento selecionado.")
	return /** @type {LocalizedString} */ ("Rendering No Selected Events")
});